<template>
  <div class="mt-3">
    <ValidationObserver ref="formObserver">
      <!-- Service form -->
      <div>
        <SubHeaderSection
          title="Servicio"
          description="Detalles del servicio solicitado"
          bg-icon="#1d58b7"
          bg-color="#f0f0f0"
        >
          <font-awesome-icon :icon="['fas', 'wrench']" size="lg" fixed-width />
        </SubHeaderSection>

        <div class="sc-sub-body">
          <!-- Problem type -->
          <ValidationProvider :rules="{required: true}" name="Tipo de equipo" v-slot="{ valid, errors }">
            <b-form-group>
              <template #label>
                <span>Tipo de equipo</span><span class="asterisk">*</span>
              </template>
              <b-select
                v-model="form.service.system_type"
                :options="equipmentTypeOptions"
                :state="(errors[0] || !valid)  ? false : true"
              >
                <template v-slot:first>
                  <option :value="null">-- Seleccionar --</option>
                </template>
              </b-select>
            </b-form-group>
          </ValidationProvider>

          <!-- Description -->
          <ValidationProvider :rules="{required: true, max: 250}" name="descripción" v-slot="{ valid, errors }">
            <b-form-group class="mt-2">
              <template #label>
                <span>Descripción del problema</span><span class="asterisk">*</span>
              </template>
              <b-textarea
                placeholder="Describa bien el problema y motivo de la llamada de servicio"
                v-model="form.service.subject"
                rows="4"
                :state="(errors[0] || !valid)  ? false : true"
              />
            </b-form-group>
          </ValidationProvider>

          <!-- Troubleshooting card -->
          <TroubleshootingModal
            :form="form"
            @save-ts-solution="saveTsSolution"
          />
        </div>
      </div>

      <!-- Attachments -->
      <div>
        <SubHeaderSection
          title="Adjuntos"
          optional
          description="Agregue los documentos que consideren relevantes para el servicio"
          bg-icon="#1d58b7"
          bg-color="#f0f0f0"
        >
          <font-awesome-icon :icon="['far', 'paperclip']" size="lg" fixed-width />
        </SubHeaderSection>

        <div class="sc-sub-body pb-3 mb-3">
          <div class="d-flex justify-content-center align-items-center">
            <div style="max-width: 575px; min-width: 240px">
              <AttachmentsUploader
                :allowedFileTypes="allowedFileTypes"
                :maxNumberOfFiles="8"
                :maxFileSize="10485760"
                :useDashboard="true"
                :dashboardHeight="150"
                @file-added="handleFileAdded"
                @file-removed="handleFileRemoved"
                @handle-done-button="handleDoneButton"
              />
            </div>
          </div>
          <div v-if="form.attachments && form.attachments.length && showAttachmentsList" class="mt-3">
            <p class="font-weight-bold mb-0" style="color: #163D7D;">Lista de adjuntos:</p>
            <ol  class="px-3 mb-0" style="max-height: 250px; overflow-y: auto">
              <li v-for="(file, idx) in form.attachments" :key="idx" style="list-style: none; margin-bottom: 2px; padding-top: 4px;">
                <div class="d-flex justify-content-between border-bottom align-items-center w-100">
                  <div>
                    <p class="text-truncate mb-0" style="font-weight: 500;">
                      <span v-if="file.type == 'document'">
                        <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
                        <span>{{ file.name }}</span>
                      </span>
                      <span v-else>
                        <font-awesome-icon :icon="['far', 'image']" fixed-width />
                        <span>{{ file.caption }}</span>
                      </span>
                    </p>
                  </div>
                  <b-button
                    variant="outline-light"
                    size="sm"
                    class="text-danger p-1"
                    @click="handleFileRemoved(idx)"
                  >
                    <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />
                  </b-button>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <!-- Create Sos button -->
      <!-- <div class="d-flex justify-content-center mb-3">
        <b-button
          type="button"
          variant="primary"
          @click="$emit('create-service-call-request')"
        >
          <span class="ml-1">Crear solicitud de OS</span>
        </b-button>
      </div> -->
    </ValidationObserver>

  </div>
</template>

<script>
import SubHeaderSection from '../SubHeaderSection'
import { ValidationObserver, ValidationProvider } from "vee-validate";
import AttachmentsUploader from '../../../shared/AttachmentsUploader'
import TroubleshootingModal from './TroubleshootingModal'
import { equipmentTypeOptions, allowedFileTypes } from '../../../../sharedOptions/serviceCallModule'

export default {
  name: 'SecondStep',
  components: { SubHeaderSection, AttachmentsUploader, TroubleshootingModal, ValidationObserver, ValidationProvider },
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return {
      equipmentTypeOptions: equipmentTypeOptions,
      allowedFileTypes: allowedFileTypes,
      showAttachmentsList: false
    }
  },
  methods: {
    // forms
    async checkFormValidity () {
      return await this.$refs.formObserver.validate()
    },
    // attachments
    handleFileAdded(file_form) {
      const rawFile = file_form.raw || file_form.file

      const preview =
        rawFile instanceof File
          ? URL.createObjectURL(rawFile)
          : file_form.preview || null

      this.form.attachments.push({
        ...file_form,
        preview
      })
    },
    handleFileRemoved (idx) {
      const file = this.form.attachments[idx]

      if (file?.preview?.startsWith('blob:')) {
        URL.revokeObjectURL(file.preview)
      }

      this.form.attachments.splice(idx, 1)
    },
    // TS
    saveTsSolution (solution) {
      this.form.service.ts_solution = solution
      if (solution.is_solved === 'Sí') {
        this.$emit('order-resolved', 'pending')
      } else {
        this.$emit('order-resolved', null)
      }
    },
    handleDoneButton () {
      this.showAttachmentsList = true
    }
  }
}
</script>

<style scoped>
  .sc-sub-body { padding: 0px 24px 24px; }

  .img-thu { max-width: 50px; max-height: 50px; }

  @media (max-width: 640px) {
    .sc-sub-body { padding-left: 16px; padding-right: 16px; }
    .ts-card-sub { display: none; }
  }
</style>
